import { isResource } from '@medplum/core'
import { codeableConcept, hasCodeableConcept } from '#src/codeableConcept.ts'
import { LIBRARY_TOPIC } from '#src/codeSystems.ts'
import {
  CompositionLibraryEncoded,
  type LibrarySection,
} from '#src/models/compositionLibraryEncoded.ts'
import { isOfType } from '#src/utils.ts'

export class AssessmentTemplate extends CompositionLibraryEncoded {
  constructor(
    data?: ConstructorParameters<typeof CompositionLibraryEncoded>[0]
  ) {
    super({
      topic: [AssessmentTemplate.libraryTopic],
      ...data,
    })
  }

  static build(
    data?: ConstructorParameters<typeof CompositionLibraryEncoded>[0]
  ): AssessmentTemplate {
    return new AssessmentTemplate({
      ...data,
    })
  }

  get sections(): AssessmentTemplateSection[] {
    return this.getSections<AssessmentTemplateSection>()
  }

  set sections(sections: AssessmentTemplateSection[]) {
    this.setSections(sections)
  }

  static libraryTopic = codeableConcept({
    system: LIBRARY_TOPIC,
    code: 'assessment',
    display: 'Assessment',
  })

  static isInstance(value: unknown): value is AssessmentTemplate {
    return (
      isResource(value) &&
      isOfType(value, 'Library') &&
      hasCodeableConcept(value.topic, AssessmentTemplate.libraryTopic)
    )
  }
}

export interface AssessmentTemplateSection extends LibrarySection {}
